import { render, staticRenderFns } from "./PayRangeVersionBar.vue?vue&type=template&id=35722252&scoped=true"
import script from "./PayRangeVersionBar.vue?vue&type=script&setup=true&lang=js"
export * from "./PayRangeVersionBar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PayRangeVersionBar.vue?vue&type=style&index=0&id=35722252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35722252",
  null
  
)

export default component.exports